export default __webpack_public_path__ + "assets/2e920b4cb1ceaa4501d41bbee6aea02b.svg";